import  {useState} from "react";
import { Input } from 'reactstrap';


function CustomInput(props) {

    let [value,updateValue] = useState(props.value);
    let className = '';

    const handleChange = element => {
        updateValue(element.target.value);
        props.onChange(element);
    };

    if(props.error){
        className="is-invalid";
    }
    return (
        <div>
            <Input
                id={'id_'+props.name} 
                onChange={handleChange}
                className={className}
                value={value}
                type={props.type}
                name={props.name}
                readOnly={props.readOnly}
                autoFocus={props.autoFocus?true:false}
                maxLength={props.maxLength}
                
            />
            {props.error && (
                <span 
                    className="error invalid-feedback" 
                    style={{display:'inline'}}>
                        {props.error}
                </span>
            )}
        </div>
    );
}
export default CustomInput;
